import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/view/index'
import about from '@/components/view/about'
import tech from '@/components/view/tech'
import product from '@/components/view/product'
import news from '@/components/view/news'
import contact from '@/components/view/contact'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/tech',
      name: 'tech',
      component: tech,
      children: [
        {path: '/tech', name: 'list', component: () => import('@/components/lib/tech/list.vue')},
        {path: '/tech/:id', name: 'more', component: () => import('@/components/lib/tech/more.vue')}
      ]
    },
    {
      path: '/product',
      name: 'product',
      component: product
      // children: [
      //   {path: '/product/ji', component: () => import('@/components/lib/tech/list.vue')},
      //   {path: '/product/door', component: () => import('@components/lib/product/door/list.vue')},
      //   {path: '/product/yetai'},
      //   {path: '/product/bianxie'},
      //   {path: '/product/hengan'}
      // ]
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: () => import('@/components/mobile/index'),
      children: [
        {path: '/mobile/index', component: () => import('@/components/mobile/index')}
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js